"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrainModelSubspace = exports.ProgressIndicator = void 0;
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
var tag_typescript_client_1 = require("@tableau/tag-typescript-client");
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var react_redux_1 = require("react-redux");
var Localize_1 = require("../../gen-src/Localize");
var TagHelpers_1 = require("../Tag/TagHelpers");
var RootReducer_1 = require("../app/RootReducer");
var Index_1 = require("../components/base/Index");
var PredictiveModelSlice_1 = require("../store/slice/PredictiveModelSlice");
var SubspaceSlice_1 = require("../store/slice/SubspaceSlice");
var PredictiveModelThunk_1 = require("../store/thunk/PredictiveModelThunk");
var LayoutStyles_1 = require("../styles/LayoutStyles");
var TestIds_1 = require("../util/TestIds");
var Utils_1 = require("../util/Utils");
var PredictiveModelJobOperations_1 = require("../vizportalapi/PredictiveModelJobOperations");
var PrometheusEditorHeader_1 = require("./PrometheusEditorHeader");
var StateSelectors_1 = require("./StateSelectors");
var ProgressStatusHelper = /** @class */ (function () {
    function ProgressStatusHelper(transferStatus, trainingStatus, transferError, trainingError, shouldCancel, previousPhase) {
        this.transferStatus = transferStatus;
        this.trainingStatus = trainingStatus;
        this.transferError = transferError;
        this.trainingError = trainingError;
        this.shouldCancel = shouldCancel;
        this.previousPhase = previousPhase;
        this.currentPhase = Utils_1.TrainingPhase.Undefined;
        this.trainingJustCompleted = false;
        if (!transferStatus) {
            this.currentPhase = Utils_1.TrainingPhase.Undefined;
            return;
        }
        if (trainingStatus === tag_typescript_client_1.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum.TrainUndefined) {
            switch (transferStatus) {
                case tag_typescript_client_1.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTransferStatusEnum.TransferPending:
                case tag_typescript_client_1.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTransferStatusEnum.TransferUndefined:
                    this.currentPhase = Utils_1.TrainingPhase.Processing;
                    break;
                case tag_typescript_client_1.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTransferStatusEnum.InProgress:
                case tag_typescript_client_1.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTransferStatusEnum.TransferSuccess:
                    this.currentPhase = Utils_1.TrainingPhase.DataMovement;
                    break;
                case tag_typescript_client_1.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTransferStatusEnum.TransferCancelled:
                case tag_typescript_client_1.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTransferStatusEnum.TransferFailed:
                    this.currentPhase =
                        this.previousPhase.current !== Utils_1.TrainingPhase.Undefined ? this.previousPhase.current : Utils_1.TrainingPhase.Processing;
                    break;
                default:
                    this.currentPhase = Utils_1.TrainingPhase.Undefined;
            }
        }
        else {
            switch (trainingStatus) {
                case tag_typescript_client_1.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum.TrainFailed:
                case tag_typescript_client_1.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum.TrainTimedOut:
                    this.currentPhase =
                        this.previousPhase.current > Utils_1.TrainingPhase.DataMovement ? this.previousPhase.current : Utils_1.TrainingPhase.DescriptiveAnalysis;
                    break;
                case tag_typescript_client_1.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum.TrainDone:
                case tag_typescript_client_1.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum.TrainSuccess:
                    this.currentPhase = Utils_1.TrainingPhase.Complete;
                    break;
                case tag_typescript_client_1.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum.RunningPredictive:
                case tag_typescript_client_1.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum.DonePredictive:
                case tag_typescript_client_1.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum.Postprocessing:
                    this.currentPhase = Utils_1.TrainingPhase.ModelCreation;
                    break;
                default:
                    this.currentPhase = Utils_1.TrainingPhase.DescriptiveAnalysis;
                    break;
            }
        }
        if (this.currentPhase === Utils_1.TrainingPhase.Complete &&
            this.previousPhase.current &&
            this.previousPhase.current !== Utils_1.TrainingPhase.Complete) {
            this.trainingJustCompleted = true;
        }
        this.previousPhase.current = this.currentPhase;
    }
    ProgressStatusHelper.prototype.isStarted = function () {
        return this.currentPhase !== Utils_1.TrainingPhase.Undefined;
    };
    ProgressStatusHelper.prototype.isInProcessing = function () {
        return this.currentPhase === Utils_1.TrainingPhase.Processing;
    };
    ProgressStatusHelper.prototype.isInDataMovement = function () {
        return this.currentPhase === Utils_1.TrainingPhase.DataMovement;
    };
    ProgressStatusHelper.prototype.isInDescriptiveAnalysis = function () {
        return this.currentPhase === Utils_1.TrainingPhase.DescriptiveAnalysis;
    };
    ProgressStatusHelper.prototype.isInModelCreation = function () {
        return this.currentPhase === Utils_1.TrainingPhase.ModelCreation;
    };
    ProgressStatusHelper.prototype.isProcessingComplete = function () {
        return this.currentPhase > Utils_1.TrainingPhase.Processing;
    };
    ProgressStatusHelper.prototype.isDataMovementComplete = function () {
        return this.currentPhase > Utils_1.TrainingPhase.DataMovement;
    };
    ProgressStatusHelper.prototype.isDescriptiveAnalysisComplete = function () {
        return this.currentPhase > Utils_1.TrainingPhase.DescriptiveAnalysis;
    };
    ProgressStatusHelper.prototype.isModelCreationComplete = function () {
        return this.currentPhase > Utils_1.TrainingPhase.ModelCreation;
    };
    ProgressStatusHelper.prototype.isAllComplete = function () {
        return this.currentPhase === Utils_1.TrainingPhase.Complete;
    };
    ProgressStatusHelper.prototype.isTrainingFailed = function () {
        return (this.shouldCancel ||
            this.transferStatus === tag_typescript_client_1.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTransferStatusEnum.TransferCancelled ||
            this.transferStatus === tag_typescript_client_1.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTransferStatusEnum.TransferFailed ||
            this.trainingStatus === tag_typescript_client_1.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum.TrainFailed ||
            this.trainingStatus === tag_typescript_client_1.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum.TrainTimedOut);
    };
    ProgressStatusHelper.prototype.isTrainingJustCompleted = function () {
        return this.trainingJustCompleted;
    };
    // TODO Are there errors that contain a code plus message that we should be parsing?
    ProgressStatusHelper.prototype.getTrainingErrorMessage = function () {
        if (this.transferError) {
            return this.transferError;
        }
        else if (this.trainingError === Utils_1.SalesforceTrainingErrors.concurrentLimitExceeded) {
            return Localize_1.Messages.salesforceConcurrentStoryCreationLimit();
        }
        else if (this.shouldCancel) {
            return Localize_1.Messages.salesforceZombieJobError();
        }
        return this.trainingError;
    };
    ProgressStatusHelper.prototype.getCurrentPhase = function () {
        return this.currentPhase;
    };
    ProgressStatusHelper.prototype.completeTitle = function () {
        if (this.isTrainingFailed()) {
            return '-';
        }
        if (this.isAllComplete()) {
            return '✓';
        }
        return '';
    };
    return ProgressStatusHelper;
}());
var ProgressIndicatorPhase = function (props) {
    var shouldAnimate = props.animate && !props.trainingFailed;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { display: 'flex', flexDirection: 'column', alignItems: 'left', justifyContent: 'flex-start' } },
            React.createElement("div", { style: { height: '50px', display: 'flex', alignItems: 'center', justifyContent: 'flex-start' } },
                shouldAnimate && (React.createElement("img", { src: "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9JzMwMHB4JyB3aWR0aD0nMzAwcHgnICBmaWxsPSIjMDAwMDAwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHBhdGggZD0iTTQ0My41LDIxOC41di0xNTBsLTU0LjksNTQuOUMzNTQuNiw4OS41LDMwNy44LDY4LjUsMjU2LDY4LjVjLTEwMy41LDAtMTg3LjUsODQtMTg3LjUsMTg3LjVjMCwxMDMuNSw4NCwxODcuNSwxODcuNSwxODcuNSAgYzEwMy41LDAsMTg3LjUtODQsMTg3LjUtMTg3LjVINDA2YzAsODIuNy02Ny4zLDE1MC0xNTAsMTUwYy04Mi43LDAtMTUwLTY3LjMtMTUwLTE1MHM2Ny4zLTE1MCwxNTAtMTUwYzQxLjQsMCw3OC45LDE2LjksMTA1LjksNDQuMSAgbC02OC40LDY4LjRINDQzLjV6Ij48L3BhdGg+PC9zdmc+", alt: "", style: { display: 'absolute', width: '32px', height: '32px', animation: 'rotation 8s infinite linear' } })),
                !shouldAnimate && (React.createElement("div", { style: {
                        width: '16px',
                        height: '16px',
                        borderRadius: 8,
                        backgroundColor: props.hasError ? '#C93A47' : props.complete ? '#42c257' : '#aaa',
                    } })),
                !props.hideComplete && React.createElement("div", { style: { width: '200px', height: '4px', backgroundColor: props.complete ? '#42c257' : '#aaa' } })),
            React.createElement("div", { style: { fontSize: '13px', height: '22px', color: props.hasError ? '#C93A47' : '#a0a0a0' } }, props.title))));
};
var ProgressIndicator = function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' } },
            React.createElement(ProgressIndicatorPhase, { complete: props.status.isProcessingComplete(), animate: props.status.isInProcessing() && !props.status.isTrainingFailed(), title: props.status.isStarted() ? Localize_1.Messages.trainingPhaseProcessingLabel() : Localize_1.Messages.trainingPhaseReadyToTrainLabel(), 
                // TODO Figure out what to do with Undefined. Call it processing, or don't mark any phase since we never started
                hasError: props.status.isTrainingFailed() &&
                    (props.status.getCurrentPhase() === Utils_1.TrainingPhase.Processing || props.status.getCurrentPhase() === Utils_1.TrainingPhase.Undefined), trainingFailed: props.status.isTrainingFailed() }),
            React.createElement(ProgressIndicatorPhase, { complete: props.status.isDataMovementComplete(), animate: props.status.isInDataMovement() && !props.status.isTrainingFailed(), title: props.status.isStarted() ? Localize_1.Messages.trainingPhaseDataMovementLabel() : '', hasError: props.status.isTrainingFailed() && props.status.getCurrentPhase() === Utils_1.TrainingPhase.DataMovement, trainingFailed: props.status.isTrainingFailed() }),
            React.createElement(ProgressIndicatorPhase, { complete: props.status.isDescriptiveAnalysisComplete(), animate: props.status.isInDescriptiveAnalysis() && !props.status.isTrainingFailed(), title: props.status.isStarted() ? Localize_1.Messages.trainingPhaseDescriptiveAnalysisLabel() : '', hasError: props.status.isTrainingFailed() && props.status.getCurrentPhase() === Utils_1.TrainingPhase.DescriptiveAnalysis, trainingFailed: props.status.isTrainingFailed() }),
            React.createElement(ProgressIndicatorPhase, { complete: props.status.isModelCreationComplete(), animate: props.status.isInModelCreation() && !props.status.isTrainingFailed(), title: props.status.isStarted() ? Localize_1.Messages.trainingPhaseModelCreationLabel() : '', hasError: props.status.isTrainingFailed() && props.status.getCurrentPhase() === Utils_1.TrainingPhase.ModelCreation, trainingFailed: props.status.isTrainingFailed() }),
            React.createElement(ProgressIndicatorPhase, { complete: props.status.isAllComplete(), title: props.status.completeTitle(), hideComplete: true, hasError: props.status.isTrainingFailed() && props.status.getCurrentPhase() === Utils_1.TrainingPhase.Complete, trainingFailed: props.status.isTrainingFailed() }))));
};
exports.ProgressIndicator = ProgressIndicator;
var TrainModelSubspace = function (props) {
    var _a = React.useState(false), trainingButtonDisabled = _a[0], setTrainingButtonDisabled = _a[1];
    var dispatch = (0, react_redux_1.useDispatch)();
    var trainingJob = (0, RootReducer_1.useAppSelector)(PredictiveModelSlice_1.selectJob);
    var userName = (0, RootReducer_1.useAppSelector)(PredictiveModelSlice_1.selectTrainingJobUsername);
    var trainingPoller = React.useRef(null);
    var previousPhase = React.useRef(Utils_1.TrainingPhase.Undefined);
    var progressStatus = React.useMemo(function () {
        return new ProgressStatusHelper(trainingJob.transferStatus, trainingJob.trainingStatus, trainingJob.transferError, trainingJob.trainingError, trainingJob.shouldCancel, previousPhase);
    }, [trainingJob]);
    var needsAuth = (0, react_redux_1.useSelector)(StateSelectors_1.needsAuthSelector);
    var model = (0, react_redux_1.useSelector)(PredictiveModelSlice_1.selectModel);
    var handleOnCredentialsAddedBeforeStartTraining = function (credential, _credentialProperties) {
        callStartTraining(credential);
    };
    React.useEffect(function () {
        if (trainingJob.id) {
            if (!progressStatus.isAllComplete() && !progressStatus.isTrainingFailed()) {
                if (!trainingPoller.current) {
                    trainingPoller.current = setTimeout(function () {
                        trainingPoller.current = null;
                        dispatch((0, PredictiveModelThunk_1.getRecentTrainingJob)());
                    }, 3000);
                }
            }
            else if (progressStatus.isTrainingJustCompleted()) {
                dispatch((0, SubspaceSlice_1.setSubspace)(Utils_1.SubspaceType.Results));
            }
            setTrainingButtonDisabled(!progressStatus.isTrainingFailed());
        }
    }, [dispatch, trainingJob, progressStatus]);
    var handleOnCredentialsAddedDuringGetStatus = function () {
        dispatch((0, SubspaceSlice_1.updateNeedsAuth)(false));
        // TODO Not sure if this is the right pattern
        setTimeout(function () {
            dispatch((0, PredictiveModelThunk_1.getRecentTrainingJob)());
        }, 1000);
    };
    var callAuthOrStartTraining = function () {
        setTrainingButtonDisabled(true);
        (0, TagHelpers_1.GetSalesForceAuthenticationStatus)({}).then(function (response) {
            // There is no easy way to make doOAuthSignIn a well-behaved Promise.
            // The problem is that doOAuthSignIn doesn't currently have callback notification on errors.
            // The AddOAuthCredentialAction in VPC does a better job and is PromiseLike, but I'm not sure if it notifies on closing the credential window manually.
            // We need a stronger guarantee that the 'Train Model' button will eventually be re-enabled.
            setTrainingButtonDisabled(false);
            if (!response.isAuthenticated) {
                (0, PrometheusEditorHeader_1.doOAuthSignIn)(props.server, handleOnCredentialsAddedBeforeStartTraining);
            }
            else {
                callStartTraining(response.credentialId ? response.credentialId : '');
            }
        }, function (reason) {
            setTrainingButtonDisabled(false);
            (0, PredictiveModelThunk_1.showErrorToast)(Localize_1.Messages.salesforceAuthenticationError());
            console.log(reason);
        });
    };
    var callCreatePredictiveModelJob = function (credentialId) { return __awaiter(void 0, void 0, void 0, function () {
        var userId, userLuId, params;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    userId = (_a = props === null || props === void 0 ? void 0 : props.server) === null || _a === void 0 ? void 0 : _a.sessionUserId;
                    userLuId = (_b = props === null || props === void 0 ? void 0 : props.server) === null || _b === void 0 ? void 0 : _b.sessionUserLuId;
                    params = {
                        luid: model.activeVersion.luid,
                        job: {
                            salesforceUserId: userId,
                            credentialId: credentialId,
                            jobOwnerLuid: userLuId,
                            jobOwnerId: parseInt(userId, 10),
                        },
                    };
                    return [4 /*yield*/, PredictiveModelJobOperations_1.PredictiveModelJobOperations.createPredictiveModelJob(params).then(function (jobId) {
                            console.log('CreatePredictiveModelJob returned with jobId: ' + jobId.toString());
                            return jobId;
                        }, function (reason) {
                            setTrainingButtonDisabled(false);
                            (0, PredictiveModelThunk_1.showErrorToast)(reason);
                        })];
                case 1: return [2 /*return*/, _c.sent()];
            }
        });
    }); };
    var callStartTraining = function (credentialId) { return __awaiter(void 0, void 0, void 0, function () {
        var jobId, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setTrainingButtonDisabled(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, callCreatePredictiveModelJob(credentialId)];
                case 2:
                    jobId = _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    console.info('could not get job id. Fallback to V1 startTraining');
                    return [3 /*break*/, 4];
                case 4:
                    if (jobId) {
                        // TODO Hack here to wait for the backend to get the job fully created before we can query for it
                        setTimeout(function () {
                            dispatch((0, PredictiveModelThunk_1.getRecentTrainingJob)());
                        }, 1000);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    React.useEffect(function () {
        var styleSheet = document.styleSheets[0];
        var keyframes = "@keyframes rotation {\n        from {transform: rotate(0deg);}\n        to {transform: rotate(359deg);}\n    }";
        styleSheet.insertRule(keyframes, styleSheet.cssRules.length);
    });
    return (React.createElement("div", { style: { width: '100%', height: '50%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' } },
        React.createElement("div", { style: { padding: '100px', alignItems: 'stretch' } },
            React.createElement(exports.ProgressIndicator, { status: progressStatus }),
            progressStatus.isStarted() && (React.createElement("div", { style: { paddingTop: '10px' } }, Localize_1.Messages.runAsUserTrainingDescription({ value: userName }))),
            needsAuth && (React.createElement("div", { style: { paddingTop: '10px' } },
                React.createElement(widgets_1.ButtonWidget, { onClick: function () { return (0, PrometheusEditorHeader_1.doOAuthSignIn)(props.server, handleOnCredentialsAddedDuringGetStatus); }, testId: TestIds_1.REAUTHENTICATE_BUTTON_TEST_ID, buttonType: widgets_1.ButtonType.Primary }, 'Re-Authenticate SalesForce')))),
        progressStatus.isTrainingFailed() && (React.createElement("div", { style: {
                marginTop: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
            } },
            React.createElement(Index_1.Error, { style: { width: '880px', justifyContent: 'flex-start' }, message: progressStatus.getTrainingErrorMessage(), testId: TestIds_1.INLINE_TRAINING_ERROR_TEST_ID }))),
        !needsAuth && (React.createElement("div", { style: {
                width: '880px',
                marginTop: '20px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                justifyContent: 'flex-start',
            } },
            React.createElement(widgets_1.ButtonWidget, { onClick: function () { return callAuthOrStartTraining(); }, testId: TestIds_1.START_TRAINING_BUTTON_TEST_ID, buttonType: widgets_1.ButtonType.Primary, disabled: trainingButtonDisabled }, Localize_1.Messages.startTrainingButton()),
            React.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.LowEmphasis, onClick: function () { return (0, PrometheusEditorHeader_1.signoutAndLaunchSalesforceLoginDialog)(props.server, function () { return void 0; }); }, testId: TestIds_1.CHANGE_CREDENTIAL_BUTTON_TEST_ID, hidden: trainingButtonDisabled, className: LayoutStyles_1.changeSalesforceCredsTextStyle }, Localize_1.Messages.changeCredentialButton())))));
};
exports.TrainModelSubspace = TrainModelSubspace;
//# sourceMappingURL=TrainModelSubspace.js.map